import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export const FinalCta = () => {
  return (
    <section id="contact" className="relative bg-[#FAF7F2] text-[#1A2238] py-24 lg:py-32 overflow-hidden">
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
        className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center"
      >
        <motion.p variants={fadeUp} className="eyebrow text-[#FF6A3D] mb-8">
          Let&rsquo;s Begin
        </motion.p>
        <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.03]">
          Ready to Become the Top Choice for Learners?
        </motion.h2>
        <motion.p variants={fadeUp} className="mt-8 text-lg text-[#1A2238]/60">
          Activate aspiration, achievement, and assurance for your learners.
        </motion.p>
        <motion.div variants={fadeUp} className="mt-12 flex justify-center">
          <a
            href="https://cal.com/raj-rakshit-ssudkn"
            data-testid="final-cta"
            className="group inline-flex items-center gap-3 bg-[#FF6A3D] text-[#FAF7F2] font-bold text-base py-2 pl-8 pr-2 rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_36px_rgba(255,106,61,0.45)]"
          >
            Unlock Your Growth
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#1A2238] text-[#FAF7F2] transition-transform duration-300 group-hover:rotate-45">
              <ArrowUpRight size={20} />
            </span>
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};
